import script from "./submit8.vue?vue&type=script&setup=true&lang=js"
export * from "./submit8.vue?vue&type=script&setup=true&lang=js"

import "./submit8.vue?vue&type=style&index=0&id=e6538d3a&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6538d3a"]])

export default __exports__